import React from "react";
import { CardProp }  from "./cmpCard_180";
import "./Card_180.css";
import Button from "../GenericComponents/Button";
import { useNavigate } from "react-router-dom";
import { colorType } from "../GenericComponents/generic.d";


const Card_180: React.FC<CardProp> = ({card}: CardProp) => {
  const navigate = useNavigate();

    return (
      <div className="card">
        <div className="context">
          <p className="label">{card.label}</p>
          <p className="description">{card.description}</p>
        </div>

        <div className="button">
          <Button 
          classProp={"yellow-button"}
          label={card.button_label}
          hasIcon={false}
          size={"small"}
          textColor={colorType.BLUE}
          onClick={() => navigate(`${card.navigateTo}`)}
          />

        </div>

      </div>
    );  
};
export default Card_180;